import React from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {AppProvider} from './context/AppContext';
import {AuthProvider} from './context/AuthContext';
import Routes from './routes';
import {BrowserRouter} from 'react-router-dom';
import {SnackbarProvider} from 'notistack';
import {ConfirmProvider} from 'material-ui-confirm';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import setDefaultOptions from 'date-fns/setDefaultOptions';
import ptBR from 'date-fns/locale/pt-BR';
import {CookiesProvider} from 'react-cookie';

setDefaultOptions({
    locale: ptBR,
});
const myTheme = createTheme({
    palette: {
        primary: {
            main: '#0CA54A',
        },
    },
});

// Object.assign(myTheme, {

//     overrides: {
//         MUIRichTextEditor: {
//             root: {
//                 border: '1px solid #ccc',
//                 borderRadius: '4px',
//             },
//             editor: {
//                 borderTop: '1px solid #ccc',
//                 paddingLeft: '30px',
//             },
//             placeHolder: {
//                 fontSize: '16px',
//                 paddingLeft: '20px',
//                 position: 'inherit',
//             },
//         },
//     },
// });

function App() {
    return (
        <ThemeProvider theme={myTheme}>
            <CookiesProvider>
                <AppProvider>
                    <AuthProvider>
                        <BrowserRouter basename="/">
                            <SnackbarProvider autoHideDuration={8000}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <ConfirmProvider defaultOptions={{
                                        confirmationText: 'Sim',
                                        cancellationText: 'Cancelar',
                                        contentProps:{
                                            dividers:true,
                                        },
                                        confirmationButtonProps:{
                                            variant: 'outlined',
                                            color: 'primary'
                                        },
                                        cancellationButtonProps:{
                                            color: 'error'
                                        }
                                    }}>
                                        <Routes />
                                    </ConfirmProvider>
                                </LocalizationProvider>
                            </SnackbarProvider>
                        </BrowserRouter>
                    </AuthProvider>
                </AppProvider>
            </CookiesProvider>
        </ThemeProvider>
    );
}

export default App;
